// extracted by mini-css-extract-plugin
export default {"findOrder":"TP-z","disabled":"UP-z","searchGroup":"VP-z","buttonGroup":"WP-z","inputGroup":"XP-z","error":"YP-z","inputGroupButton":"ZP-z","searchPrompt":"_P-z","return":"aQ-z"};